import { bindActionCreators } from "redux";
import { call, put, take } from "redux-saga/effects";

import * as apiCaller from "../../api/apiCaller";

export const GET_LIST_EXTENSION = "GET_LIST_EXTENSION";
export const GET_LIST_EXTENSION_ERROR = "GET_LIST_EXTENSION_ERROR";
export const GET_LIST_EXTENSION_SUCCESS = "GET_LIST_EXTENSION_SUCCESS";
export const GET_LIST_ARRAY_EXTENSION_SUCCESS =
  "GET_LIST_ARRAY_EXTENSION_SUCCESS";

export const COUNT_LIST_EXTENSION = "COUNT_LIST_EXTENSION";
export const COUNT_LIST_EXTENSION_ERROR = "COUNT_LIST_EXTENSION_ERROR";
export const COUNT_LIST_EXTENSION_SUCCESS = "COUNT_LIST_EXTENSION_SUCCESS";

export const DELETE_EXTENSION = "DELETE_EXTENSION";
export const DELETE_EXTENSION_ERROR = "DELETE_EXTENSION_ERROR";
export const DELETE_EXTENSION_SUCCESS = "DELETE_EXTENSION_SUCCESS";

export const EDIT_EXTENSION = "EDIT_EXTENSION";
export const EDIT_EXTENSION_SUCCESS = "EDIT_EXTENSION_SUCCESS";
export const EDIT_EXTENSION_ERROR = "EDIT_EXTENSION_ERROR";

export const ADD_EXTETNSION = "ADD_EXTETNSION";
export const ADD_EXTETNSION_SUCCESS = "ADD_EXTETNSION_SUCCESS";
export const ADD_EXTETNSION_ERROR = "ADD_EXTETNSION_ERROR";
/**
 * Reducer
 */

const initialState = {
  extensions: [],
  error: false,
  count: 0,
  loading: false,
};

export const extensionsReducer = (state = initialState, action) => {
  switch (action.type) {
    //get list
    case GET_LIST_EXTENSION:
      return {
        ...state,
        loading: true,
      };
    case GET_LIST_EXTENSION_SUCCESS:
      return {
        ...state,
        loading: false,
        extensions: action.payload,
      };
    case GET_LIST_ARRAY_EXTENSION_SUCCESS:
      return {
        ...state,
        loading: false,
        array: action.payload,
      };
    case GET_LIST_EXTENSION_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };
    //count list
    case COUNT_LIST_EXTENSION:
      return {
        ...state,
        loading: true,
      };
    case COUNT_LIST_EXTENSION_SUCCESS:
      return {
        ...state,
        loading: false,
        count: action.payload,
      };
    case COUNT_LIST_EXTENSION_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };
    //delete list
    case DELETE_EXTENSION:
      return {
        ...state,
      };
    case DELETE_EXTENSION_SUCCESS:
      return {
        ...state,
        extension: action.payload,
      };
    case DELETE_EXTENSION_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //EDIT
    case EDIT_EXTENSION:
      return {
        ...state,
      };
    case EDIT_EXTENSION_SUCCESS:
      return {
        ...state,
        extension: action.payload,
      };
    case EDIT_EXTENSION_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //add
    case ADD_EXTETNSION:
      return {
        ...state,
      };
    case ADD_EXTETNSION_SUCCESS:
      return {
        ...state,
        extension: action.payload,
      };
    case ADD_EXTETNSION_ERROR:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
};

/**
 * Action
 */
export const getListExtension = (
  order,
  limit,
  skip,
  where,
  include,
  fields
) => ({
  type: GET_LIST_EXTENSION,
  data: {
    order,
    limit,
    skip,
    where,
    include,
    fields,
  },
});

export const countListExtension = (where) => ({
  type: COUNT_LIST_EXTENSION,
  data: {
    where,
  },
});

export const deleteExtension = (id) => ({
  type: DELETE_EXTENSION,
  data: {
    id,
  },
});

export const editExtension = (
  id,
  name,
  type,
  tags,
  password,
  defaultNumberId,
  subOrg,
  agentView
) => ({
  type: EDIT_EXTENSION,
  data: {
    id,
    name,
    type,
    tags,
    password,
    defaultNumberId,
    subOrg,
    agentView,
  },
});

export const addExtension = (
  name,
  type,
  tags,
  defaultNumberId,
  subOrg,
  agentView
) => ({
  type: ADD_EXTETNSION,
  data: {
    name,
    type,
    tags,
    defaultNumberId,
    subOrg,
    agentView,
  },
});

export const mapActionsToProps = (dispatch) => {
  return bindActionCreators(
    {
      getListExtension,
      deleteExtension,
      editExtension,
      addExtension,
      countListExtension,
    },
    dispatch
  );
};

/**
 * Apis
 */

const getListExtensionApi = (order, limit, skip, where, include, fields) => {
  return apiCaller.getLogs("/cloud-pbx/extension", {
    order,
    limit,
    skip,
    ...where,
    ...include,
    ...fields,
  });
};

const countListExtensionApi = (where) => {
  return apiCaller.getData("/cloud-pbx/extension/count", { ...where });
};

const deleteExtensionApi = (id) => {
  // return apiCaller.del(`/cloud-pbx/extension/${id}`)
  return apiCaller.post(`/cloud-pbx/extension/delete-extension/${id}`);
};

const addExtensionApi = (
  name,
  type,
  tags,
  defaultNumberId,
  subOrg,
  agentView
) => {
  return apiCaller.post("/cloud-pbx/extension", {
    name,
    type,
    ...tags,
    defaultNumberId,
    subOrg,
    agentView,
  });
};

const editExtensionApi = (
  id,
  name,
  type,
  tags,
  password,
  defaultNumberId,
  subOrg,
  agentView
) => {
  return apiCaller.put(`/cloud-pbx/extension/${id}`, {
    name,
    type,
    ...tags,
    password,
    defaultNumberId,
    subOrg,
    agentView,
  });
};

/**
 * sagas
 */

export const getListExtensionFlow = function* () {
  while (true) {
    const action = yield take(GET_LIST_EXTENSION);
    try {
      const res = yield call(
        getListExtensionApi,
        action.data.order,
        action.data.limit,
        action.data.skip,
        action.data.where,
        action.data.include,
        action.data.fields
      );
      let data = [];
      res.data.sort(function (a, b) {
        return (
          new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
        );
      });
      for (const key in res.data) {
        if (res.data.hasOwnProperty(key)) {
          const val = res.data[key];
          if (val) {
            data.push({
              id: val.id,
              value: val.username,
              label: `${val.name} - ${val.username}`,
            });
          }
        }
      }
      yield put({ type: GET_LIST_ARRAY_EXTENSION_SUCCESS, payload: res.data });
      res.data["extension"] = data;
      yield put({ type: GET_LIST_EXTENSION_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: GET_LIST_EXTENSION_ERROR, error });
    }
  }
};

export const deleteExtensionFlow = function* () {
  while (true) {
    const action = yield take(DELETE_EXTENSION);
    try {
      const res = yield call(deleteExtensionApi, action.data.id);
      yield put({ type: DELETE_EXTENSION_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: DELETE_EXTENSION_ERROR, error });
    }
  }
};
export const editExtensionFlow = function* () {
  while (true) {
    const action = yield take(EDIT_EXTENSION);
    try {
      const res = yield call(
        editExtensionApi,
        action.data.id,
        action.data.name,
        action.data.type,
        action.data.tags,
        action.data.password,
        action.data.defaultNumberId,
        action.data.subOrg,
        action.data.agentView
      );
      yield put({ type: EDIT_EXTENSION_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: EDIT_EXTENSION_ERROR, error });
    }
  }
};
export const addExtensionFlow = function* () {
  while (true) {
    const action = yield take(ADD_EXTETNSION);
    try {
      const res = yield call(
        addExtensionApi,
        action.data.name,
        action.data.type,
        action.data.tags,
        action.data.defaultNumberId,
        action.data.subOrg,
        action.data.agentView
      );
      yield put({ type: ADD_EXTETNSION_SUCCESS, payload: { ...res.data } });
    } catch (error) {
      yield put({ type: ADD_EXTETNSION_ERROR, error });
    }
  }
};

export const countExtensionFlow = function* () {
  while (true) {
    const action = yield take(COUNT_LIST_EXTENSION);
    try {
      const res = yield call(countListExtensionApi, action.data.where);
      yield put({
        type: COUNT_LIST_EXTENSION_SUCCESS,
        payload: { ...res.data },
      });
    } catch (error) {
      yield put({ type: COUNT_LIST_EXTENSION_ERROR, error });
    }
  }
};
